 const getBaseURL = () => {     const currentHost = window.location.hostname; 
    if (currentHost.startsWith('www.')) {
        return '';
    } else {
        return '';
    }
    
};

const baseURL = getBaseURL(); 

export default baseURL;

